import type { PropsWithChildren } from "react";
import styles from "./InlineNotice.module.css";

interface InlineNoticeProps extends PropsWithChildren {
  tone?: "info" | "success" | "warning" | "error";
  title?: string;
}

export function InlineNotice({ tone = "info", title, children }: InlineNoticeProps) {
  return (
    <div className={[styles.notice, styles[tone]].filter(Boolean).join(" ")} role={tone === "error" ? "alert" : "status"}>
      <span className={styles.indicator} aria-hidden="true" />
      <div>
        {title ? <strong>{title}</strong> : null}
        <span>{children}</span>
      </div>
    </div>
  );
}
